import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Menubar from "./Menubar";
import MenuItemListComponent from "./MenuItemListComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchDeliverySlots,
  FetchWebShopCategories,
  FetchWebShopProductList,
  FetchWebshopProductsInfo,
  getWebshopFields,
} from "../../api/Webshop.service";
import {
  resetWebshop,
  setIsProductLoading,
  setWebshopCategoryData,
  setWebshopFileds,
  setWebshopLoading,
  setWebshopProductData,
  setWebshopProductInfo,
  setWebshopRelatedProductsInfo,
  updateDeliverySlots,
  updateGuestDetails,
  updateSelectedMenuItem,
} from "../../store/slice/Webshop.slice";
import { Outlet, useNavigate } from "react-router-dom";
import SelectMenuItemComponent from "./SelectMenuItemComponent";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { getCompanyStatus } from "../../utils/utils";
import InactivityPopup from "../Kiosk/InActivityPopup";
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
const MenuComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    webShopMenuPosition,
    defaultLanguage,
    selectedMenuItem,
    isProductLoading,
    webShopProductList,
    webshopSettings,
    webshopOpeningHours,
    deliveryType
  } = useSelector((store) => store?.Webshop);
 const isNullValue = (value) =>
 value === null || value === "null";


  const { key,resType,widgetConfig,widgetSetupId } = useSelector((store) => store?.widgetSettings);
  const getProductList = async (selectedMenuItem) => {
    dispatch(setWebshopProductData([]));
    dispatch(setIsProductLoading(true));
    try {
      const response = await FetchWebShopProductList(
        key,
        defaultLanguage,
        selectedMenuItem?.idCategory
      );

      if (response?.status !== 200) {
        console.error("Error fetching product list:", response);
        dispatch(setIsProductLoading(false));
      } else {
        dispatch(
          setWebshopProductData(
            response?.data
          )
        );
      }
      dispatch(setIsProductLoading(false));
    } catch (error) {
      console.error("Error fetching product list:", error);
      dispatch(setIsProductLoading(false));
    }
  };
  const getProductsInfo = async (key, defaultLanguage) => {
    try {
      const productInfo = await Promise.all(
        webShopProductList.map(async (item) => {
          const productDataDetails = await FetchWebshopProductsInfo(
            key,
            defaultLanguage,
            item?.idproduct
          );
          return productDataDetails?.data; 
        })
      );
      if (!productInfo) {
        console.error("Error fetching product list:", productInfo);
      } else {
    
        dispatch(setWebshopProductInfo(productInfo));
      }
    } catch (error) {
      dispatch(setIsProductLoading(false));
    } finally {
      dispatch(setIsProductLoading(false));
    }
  };
  const getGuestFieldDetails = async () => {
    const response = await getWebshopFields(key, defaultLanguage);
    if (response.success === false) {
      console.error(response.message); 
    } else {
      dispatch(setWebshopFileds(response));
    }
  };
  const getDeliverySlots = async (key) => {
    try {
      const response = await FetchDeliverySlots(key);
      if (response?.status !== 200) {
        console.error("Error delivery slots:", response);
      } else {
    
        dispatch(
          updateDeliverySlots(
            response?.data
          )
        );
      }
    } catch (error) {
      console.error("Error delivery slots:", error);
    }
  };
  useEffect(() => {
    getDeliverySlots(key);
  }, [key]);



  useEffect(() => {
    getProductList(selectedMenuItem);
  }, [selectedMenuItem]);

  useEffect(() => {
    getGuestFieldDetails(); 
  }, []);
  const handleMenuClick = (item) => {
    getProductList(item);
    getProductsInfo(key, defaultLanguage);
    dispatch(updateSelectedMenuItem(item));
    navigate("/webshopMenuItem");
  };
  const handleCancelAction = () => {
    console.log("User canceled the operation due to inactivity.");
  };



  return (
    <Box id='menu_comp'>
     {resType == 'kiosk' && <InactivityPopup onConfirmCancel={handleCancelAction} />}
      {!getCompanyStatus(
        webshopOpeningHours?.value?.data?.openTime,
        webshopOpeningHours?.value?.data?.closeTime,
        webshopOpeningHours?.value?.data?.companyOpen,
        webshopOpeningHours?.value?.data?.deliveryFrom,
        webshopOpeningHours?.value?.data?.deliveryTo,
        webshopOpeningHours?.value?.data?.delivery,
        deliveryType
      )?.status && (
        <Box
          sx={{
            width: "100%",
          
            backgroundColor: "#fff3f3", 
            borderBottom: "1px solid #f44336", 
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
            textAlign: "center",
            py: 1.5,
          }}
        >
          <Typography
            sx={{
              color: "#c62828",
              fontWeight: 600,
              fontSize: "1.1rem",
              fontFamily: "Roboto, sans-serif",
              letterSpacing: "0.5px",
            }}
          >
            {
              getCompanyStatus(
                webshopOpeningHours?.value?.data?.openTime,
                webshopOpeningHours?.value?.data?.closeTime,
                webshopOpeningHours?.value?.data?.companyOpen,
                webshopOpeningHours?.value?.data?.deliveryFrom,
                webshopOpeningHours?.value?.data?.deliveryTo,
                webshopOpeningHours?.value?.data?.delivery,
                deliveryType
              )?.message
            }
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: webShopMenuPosition == "vertical" ? "flex" : "block",
          backgroundColor: "#EBEBEB",
          height: "100vh",
          scrollbarWidth: "none",   // Firefox
          msOverflowStyle: "none",  // IE
          "&::-webkit-scrollbar": {
            display: "none",        // Chrome, Safari
          },
        }}
      >
        <Menubar
          getProductList={getProductList}
          getProductsInfo={getProductsInfo}
        />
        {webShopMenuPosition && isProductLoading ? (
          <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={isProductLoading}
            onClick={() => setIsProductLoading(false)}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          !isNullValue(webShopMenuPosition) && <Outlet />
        )}
      </Box>
    </Box>
  );
};

export default MenuComponent;
